var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListCheckSolidFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.05,
    height: 424.051,
    viewBox: "0 0 512.05 424.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-check-solid-full",
    d: "M197.8,100.3a23.944,23.944,0,0,1,5.9,33.4l-56,80A24.248,24.248,0,0,1,111,217L71,177a24.042,24.042,0,0,1,34-34l19.8,19.8,39.6-56.6A23.944,23.944,0,0,1,197.8,100.3Zm0,160a23.944,23.944,0,0,1,5.9,33.4l-56,80A24.248,24.248,0,0,1,111,377L71,337a23.971,23.971,0,0,1,33.9-33.9l19.8,19.8,39.6-56.6a23.944,23.944,0,0,1,33.4-5.9ZM288,160a31.966,31.966,0,0,1,32-32H544a32,32,0,0,1,0,64H320A31.966,31.966,0,0,1,288,160Zm0,160a31.966,31.966,0,0,1,32-32H544a32,32,0,0,1,0,64H320A31.966,31.966,0,0,1,288,320ZM224,480a31.966,31.966,0,0,1,32-32H544a32,32,0,0,1,0,64H256A31.966,31.966,0,0,1,224,480Zm-96-40a40,40,0,1,1-40,40A39.989,39.989,0,0,1,128,440Z",
    transform: "translate(-63.95 -95.949)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListCheckSolidFull);
export default __webpack_public_path__ + "static/media/list-check-solid-full.b017ead84271e317337b090f6ed46713.svg";
export { ForwardRef as ReactComponent };